import FeedbackButtonContainer from './containers/FeedbackButtonContainer'

export default FeedbackButtonContainer
